/* eslint-disable no-use-before-define */
import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    TextField,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import getFlag from '../../../libs/emojyFlag';
import locations from '../../../containers/GuestPortal/Screens/BackgroundCheck/components/locations';

const useStyles = makeStyles({
    option: {
        fontSize: 15,
        '& > span': {
            marginRight: 10,
            fontSize: 18,
        },
    },
});

const SelectCountry = ({variant, fullWidth, label, placeholder, input, meta: {touched, invalid, error}, autocompleteProps, ...custom}) => {
    const classes = useStyles();
    const {onChange, name, ...inputProps} = input;

    const handleSelect = (event, value = {}) => {
        // input.onChange comes from redux.form
        if (onChange && value) {
            onChange(value.code);
        }
    };

    return (
        <Autocomplete
            id={`country-select-${input.name}`}
            options={locations.countries}
            classes={{option: classes.option}}
            fullWidth={fullWidth}
            disabled={custom.disabled}
            autoHighlight
            onChange={handleSelect}
            getOptionLabel={(option = {}) => option.name}
            getOptionSelected={(option, value) => option.code === value.code}
            renderOption={(option = {}) => (
                <React.Fragment>
                    <span>{getFlag(option.code)}</span>
                    {option.name}
                </React.Fragment>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    name={name}
                    helperText={(invalid && error) || custom.helperText}
                    label={label}
                    placeholder={placeholder}
                    error={invalid || Boolean(custom.error || error)}
                    variant={variant}
                    inputProps={{
                        ...params.inputProps,
                        value: params.inputProps.value || input.value,
                        autoComplete: 'off', // disable autocomplete and autofill
                    }}
                />
            )}
            {...autocompleteProps}
        />
    );
};

SelectCountry.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
};

export default SelectCountry;